import React from 'react';
import { CommandDetailLine } from 'components/atoms/Texts/CommandDetailLine';
import useStyle from './commandeSingle.style';
import { ClientInput } from '../../graphql/generated/graphql';
import { firstCharToUpperCase } from 'helpers/text/firstCharToUpperCase';

export interface ClientDetailProps {
  client: ClientInput;
  variant?: 'default' | 'recapCommande';
}

const ClientDetail = ({ client, variant = 'default' }: ClientDetailProps) => {
  const classes = useStyle();
  if (!client)
    return (
      <p className={classes.redText}>
        Veuillez retrouver les informations du client et communiquer le numéro
        de la commande
      </p>
    );
  return (
    <div>
      {client.clientpro && (
        <p className={classes.redText}>
          Client professionnel de la société : {client.nomsociete}
        </p>
      )}
      <CommandDetailLine
        withDivider={true}
        title="Civilité"
        text={firstCharToUpperCase(client.civilite)}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Nom"
        text={client.nom}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Prénom"
        text={client.prenom}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Adresse email"
        text={client.mail}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Téléphone"
        text={client.tel}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Adresse de facturation"
        text={client.adressefacturation}
        variant={variant}
      />
      <CommandDetailLine
        withDivider={true}
        title="Ville"
        text={client.villefacturation}
        variant={variant}
      />
      <CommandDetailLine
        title="Code Postal"
        text={client.cpfacturation}
        variant={variant}
      />
    </div>
  );
};

export default ClientDetail;
